module.exports = __webpack_public_path__ + "img/img151_9.c75e3a18.png";